import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Brush } from 'recharts';
import { ChartContainer, ChartTooltip, ChartTooltipContent } from '@/components/ui/chart';
import { CustomTooltip } from './CustomTooltip';

interface UsersGrowthChartProps {
  data: { date: string; count: number }[];
}

export const UsersGrowthChart = ({ data }: UsersGrowthChartProps) => {
  const chartConfig = {
    count: {
      label: 'Novos Usuários',
      color: 'hsl(var(--primary))',
    },
  };

  return (
    <ChartContainer config={chartConfig} className="h-[300px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
          <XAxis
            dataKey="date"
            tick={{ fontSize: 12 }}
            tickFormatter={(value) => {
              const date = new Date(value);
              return `${date.getDate()}/${date.getMonth() + 1}`;
            }}
          />
          <YAxis tick={{ fontSize: 12 }} />
          <Tooltip content={<CustomTooltip />} />
          <Line
            type="monotone"
            dataKey="count"
            stroke="hsl(var(--primary))"
            strokeWidth={2}
            dot={{ fill: 'hsl(var(--primary))' }}
            animationDuration={800}
            animationEasing="ease-in-out"
          />
          <Brush dataKey="date" height={30} stroke="hsl(var(--primary))" />
        </LineChart>
      </ResponsiveContainer>
    </ChartContainer>
  );
};
